module.exports = __webpack_public_path__ + "img/lk-menu-cancel.7f0244ec.svg";